import * as d3 from "d3";

export function interruptAxisTransition(
    axis: d3.Selection<SVGGElement, any, any, any>,
    name?: string
): void {
    if (!axis) return;
    axis.selectAll("*").interrupt(name);
}
